<script>
import { BInputGroup } from "bootstrap-vue";

export default {
  extends: BInputGroup
};
</script>